module.exports = __webpack_public_path__ + "img/10-sdg-border@2x.6868562e.png";